module.exports = __webpack_public_path__ + "resources/img/img_rancher2_m.ceee68715f19fb3db3b9966f88d02309.png";